export default function fancyBox(){
    if(document.querySelector("[data-fancybox='gallery']")){
        Fancybox.bind("[data-fancybox='gallery-video']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='gallery']")){
        Fancybox.bind("[data-fancybox='unities-image']", {
            Thumbs: {
                type: "classic",
            },
        });
    }
}